"use client";

import { useConvexAuth } from "convex/react";

/**
 * Gate Convex queries until Clerk + Convex auth are ready.
 * Prevents [NO_IDENTITY] on hard reload or token refresh.
 */
export function useConvexAuthReady() {
  const { isLoading, isAuthenticated } = useConvexAuth();
  return { isLoading, isAuthenticated, canQuery: isAuthenticated };
}
